import request from '@/utils/request'
// 公众号列表
export function getList(params) {
  return request({
    url: '/novel_management/wechat_accounts',
    method: 'get',
    params
  })
}
// 编辑公众号列表
export function modify(id, params) {
  return request({
    url: `/novel_management/wechat_accounts/${id}`,
    method: 'put',
    params
  })
}

// 获取授权URL
export function getURL() {
  return request({
    url: `/get_auth_url`,
    method: 'get'
  })
}

// 获取账户余额
export function getBalance(params) {
  return request({
    url: `/account_management/account_funds`,
    method: 'get',
    params
  })
}
// 小程序 获取列表
export function getwechat(params) {
  return request({
    url: `/wechat/mini_program`,
    method: 'get',
    params
  })
}

// 小程序 新增
export function addwechat(data) {
  return request({
    url: `/wechat/mini_program`,
    method: 'post',
    data
  })
}
// 编辑
// export function updatawechat(id) {
//   return request({
//     url: `/wechat/mini_program/${id}`,
//     method: 'PUT'

//   })
// }
// 编辑
export function updatawechat(id, data) {
  return request({
    url: `/wechat/mini_program/${id}`,
    method: 'put',
    data
  })
}
// 删除

export function deletewechat(id) {
  return request({
    url: `/wechat/mini_program/${id}`,
    method: 'DELETE'
  })
}

export function getcallrecord(params) {
  return request({
    url: `/jixin/record`,
    method: 'get',
    params
  })
}

export function importReport(data = {}) {
  return request({
    url: `/import/mini_program`,
    method: 'post',
    data
  })
}

// qq扫码登录
export function qqShouQuan(obj = {}) {
  return request({
    url: `/simulation_auth_qq`,
    method: 'get',
    ...obj
  })
}

// 同步备注
export function syncNotes(obj = {}) {
  return request({
    url: `/adq_advertiser_note_scan`,
    method: 'get',
    ...obj
  })
}

// adq扫码登录
export function adqShouQuan(obj = {}) {
  return request({
    url: `/ad_copy/adq_advertiser_scan`,
    method: 'get',
    ...obj
  })
}
// 批量拉取素材和素材报表  巨量
export function advertisersjl(data = {}) {
  return request({
    url: '/ocean/advertiser/batch_pull_material_and_cost_day',
    method: 'post',
    data
  })
}
// 批量暂停素材和素材报表  巨量
export function stopCopyAd(data = {}) {
  return request({
    url: '/ocean/advertiser/stop_ocean_project',
    method: 'post',
    data
  })
}
// 查询所有公众号
export function query_wechat_account_name(params) {
  return request({
    url: `/wechat_official/replay_info/query_wechat_account_name`,
    method: 'get',
    params
  })
}
// 查询公众号配置的回复信息
export function replay_infoIndex(params) {
  return request({
    url: `/wechat_official/replay_info/index`,
    method: 'get',
    params
  })
}
// 创建公众号配置的回复信息
export function replay_infoStore(data = {}) {
  return request({
    url: '/wechat_official/replay_info/store',
    method: 'post',
    data
  })
}
// 修改公众号配置的回复信息
export function replay_infoUpdate(data = {}) {
  return request({
    url: '/wechat_official/replay_info/update',
    method: 'post',
    data
  })
}
// 删除公众号配置的回复信息
export function replay_infoDelete(data = {}) {
  return request({
    url: '/wechat_official/replay_info/delete',
    method: 'post',
    data
  })
}
// 创建或修改公众号配置的回复信息
export function update_or_create(data) {
  return request({
    url: `/wechat_official/replay_info/update_or_create`,
    method: 'post',
    data
  })
}
// 通过公众号ID查询配置的回复信息
export function replay_infos(params) {
  return request({
    url: `/wechat_official/replay_info/infos`,
    method: 'get',
    params
  })
}
// 区域后校验
export function checkarea(data) {
  return request({
    url: `/ad_copy/check_area`,
    method: 'post',
    data
  })
}
// 批量移除区域
export function removearea(data) {
  return request({
    url: `/ad_copy/remove_area`,
    method: 'post',
    data
  })
}
// 批量修改监测链接
export function updAdFeedback(data) {
  return request({
    url: `/ad_copy/upd_ad_feedback`,
    method: 'post',
    data
  })
}
// 批量修改监测链接
export function updAdLog(params) {
  return request({
    url: `/ad_copy/upd_ad_log`,
    method: 'get',
    params
  })
}
// 批量修改监测链接
export function updAdLognew(params) {
  return request({
    url: `/ad_management/audience/record`,
    method: 'get',
    params
  })
}
// 按产品名采集 / 删除广告 — 日志列表
export function delAdsByMarketingAssetNameLog(params) {
  return request({
    url: `/ad_copy/del_ads_by_marketing_asset_name_log`,
    method: 'get',
    params
  })
}
// 按日志 id 执行删除产品广告（腾讯）
export function delAdsByProductLogIds(data) {
  return request({
    url: `/ad_copy/del_ads_by_product_log_ids`,
    method: 'post',
    data
  })
}
// 批量删除监测链接
export function sprdeletecover(data) {
  return request({
    url: `/ocean/advertiser/del_ocean_project`,
    method: 'post',
    data
  })
}
// 批量修改备注(巨量)
export function advertiserchangeremark(data) {
  return request({
    url: `/ocean/advertiser/change_remark`,
    method: 'post',
    data
  })
}
// 获取实名令牌授权地址
export function userauthorizeurl(params) {
  return request({
    url: `/account_management/user_authorize_url`,
    method: 'get',
    params
  })
}
// 获取实名令牌有效期
export function userauthorizeexpire(params) {
  return request({
    url: `/account_management/user_authorize_expire`,
    method: 'get',
    params
  })
}
